'use strict';

module.exports = Number.isFinite || function (value) {
	return !(typeof value !== 'number' || value !== value || value === Infinity || value === -Infinity);
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/is-finite/index.js
// module id = 1LPp
// module chunks = 0